// Import React and the Suspense component
import React, { Suspense } from 'react';

// Import the necessary components from the react-router-dom library
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// Import custom components
import Home from './Home';
import NotFound from './NotFound';

// Import CSS file
import '../assets/main.css';


// Define the main App component
function App() {
  // Render the following JSX code
  return (
    // Use the Suspense component to handle loading states
    <Suspense fallback={null}>
      {/* Set up client-side routing using the Router component */}
      <Router basename={'/consumerspending/fr/'}>
        {/* Use the Switch component to define different routes */}
        <Switch>
          {/* Define the home page route */}
          <Route exact path="/Home" component={Home} />
          {/* Define the default route */}
          <Route exact path="/" component={Home} />
          {/* Define the "404 Not Found" route */}
          <Route component={NotFound} />
        </Switch>
      </Router>
    </Suspense>
  );
}

// Export the App component as the default export
export default App;
